import type { Contract, Values } from "./attribute"
import { HANDOFF_SOURCE_PARAM, SESSION_TOKEN_PARAM } from "./params"

export interface HandoffSenderOptions<C extends Contract> {
  readonly contract: C
  readonly source: string
  readonly sessionToken?: () => string | null | undefined
  readonly credentialParam?: string
}

export class HandoffSender<const C extends Contract> {
  constructor(private readonly options: HandoffSenderOptions<C>) {}

  buildUrl(href: string, values: Values<C>): string {
    const url = new URL(href)

    const sessionToken = this.options.sessionToken?.()
    if (sessionToken) {
      url.searchParams.set(
        this.options.credentialParam ?? SESSION_TOKEN_PARAM,
        sessionToken
      )
    }

    for (const [key, attribute] of Object.entries(this.options.contract)) {
      const value = values[key]
      if (value === undefined) {
        continue
      }

      const encoded = String(value)
      if (encoded) {
        url.searchParams.set(attribute.param, encoded)
      }
    }

    url.searchParams.set(HANDOFF_SOURCE_PARAM, this.options.source)

    return url.toString()
  }

  send(target: Window, href: string, values: Values<C>): void {
    target.location.href = this.buildUrl(href, values)
  }
}
